import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const USER: AppRouteRecordRaw = {
    path: '/system',
    name: 'system',
    component: DEFAULT_LAYOUT,
    meta: {
        locale: 'menu.system',
        icon: 'icon-storage',
        requiresAuth: true,
        order: 2,
    },
    children: [
        {
            path: '/menus',
            name: 'menus-management',
            component: () => import('@/views/menus/index.vue'),
            meta: {
                locale: 'menu.management',
                requiresAuth: true,
                roles: ['*'],
            },
        },
        {
            path: 'users',
            name: 'users-management',
            component: () => import('@/views/users/index.vue'),
            meta: {
                locale: 'users.management',
                requiresAuth: true,
                roles: ['*'],
            },
        },
    ],
};

export default USER;
